module.exports = __webpack_public_path__ + "22f480b6629d7fd6aa3cb4768221c5d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio2/3rd-FLOOR_VIEW-4_B.jpg
// module id = 905
// module chunks = 0